/*
 * @Author: jake
 * @Date: 2019-01-20 11:51:30
 * @Last Modified by: jake
 * @Last Modified time: 2020-02-18 11:44:51
 * 工具类型的封装都放在这里
 */
/**
 * @export
 * @param {查询对象} object
 * @returns
 */

import _ from 'lodash'

const _helper = {
  getImgUrl(url) {
    return this.$env.res + '/src' + url
  },
  /**
   * 改变页面title的值
   */
  setDomTitle(str) {
    document.title = str
  },
  setTitle(name) {
    document.title = name;
    if (!this.$helper.isWeiXinAndIos()) return
    // 以下是微信并且是Ios环境处理  在低版本的ios下微信浏览器不会监听title变化所以会导致加载title错误
    var iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    // 替换成站标favicon路径或者任意存在的较小的图片即可
    iframe.setAttribute('src', '')    //pic.ico为小图片url
    var iframeCallback = function () {
      setTimeout(function () {
        iframe.removeEventListener('load', iframeCallback)
        document.body.removeChild(iframe)
      }, 0)
    }
    iframe.addEventListener('load', iframeCallback)
    document.body.appendChild(iframe)
  },
  /**
   * 判断字符串是否是json
   */
  isJSON(str) {
    str = str.replace(/\s/g, '').replace(/\n|\r/, '')

    if (/^\{(.*?)\}$/.test(str)) { return /"(.*?)":(.*?)/g.test(str) }

    if (/^\[(.*?)\]$/.test(str)) {
      return str.replace(/^\[/, '')
        .replace(/\]$/, '')
        .replace(/},{/g, '}\n{')
        .split(/\n/)
        .map(s => { return this.isJSON(s) })
        .reduce((prev, curr) => { return !!curr })
    }

    return false
  },
  /**
   * 存储sessionStorage
   */
  setSessionStorage(name, content) {
    if (!name) return
    const data = window.sessionStorage.getItem(name)
    if (data && this.isJSON(data)) {
      content = this.extend(JSON.parse(data), content)
    }
    if (typeof content !== 'string') {
      content = JSON.stringify(content)
    }

    window.sessionStorage.setItem(name, content)
  },
  /**
   * 得到sessionStorage
   */
  getSessionStorage(name) {
    if (!name) return
    let data = window.sessionStorage.getItem(name)
    if (!data) {
      return false
    }
    if (
      this.isJSON(data) ||
      (data.indexOf('[') !== -1 && data.indexOf('[') <= 1)
    ) {
      const json = JSON.parse(data)
      data = json
    }
    return data
  },
  /**
   * 删除sessionStorage
   */
  removeSessionStorage(name) {
    if (!name) return
    window.sessionStorage.removeItem(name)
    return true
  },
  setStore(content, childName) {
    let name = this.getHash()
    if (typeof content !== 'string') {
      let data = window.localStorage.getItem(name) || '{}'
      data = JSON.parse(data)
      try {
        if (this.type(childName) === 'string') {
          data[childName] = content || {}
          content = JSON.stringify(data)
        } else {
          content = JSON.stringify(content)
        }
      } catch (error) {
        return error
      }
    }
    window.localStorage.setItem(name, content)
    return true
  },
  removeStore(name, childName) {
    if (!name) return false
    if (childName) {
      let data = window.localStorage.getItem(name)
      if (this.type(data) === 'object') {
        delete data[childName]
      } else if (this.type(data) === 'array') {
        data.splice(Number(childName), 1)
      } else {
        return false
      }
      window.localStorage.setItem(name, data)
    } else {
      window.localStorage.removeItem(name)
    }
    return true
  },
  getStore(name, childName) {
    if (!name) name = this.getHash()
    let data = window.localStorage.getItem(name)
    if (!data) {
      return false
    }
    try {
      data = JSON.parse(data)
      if (childName) data = data[childName]
    } catch (error) {
      return data
    }
    return data
  },
  getScrollTop() {
    let scrollTop = 0
    let bodyScrollTop = 0
    let documentScrollTop = 0
    if (document.body) {
      bodyScrollTop = document.body.scrollTop
    }
    if (document.documentElement) {
      documentScrollTop = document.documentElement.scrollTop
    }
    scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
    return scrollTop
  },
  createJs(src, succ) {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = src
    let fig = false
    document.getElementsByTagName('head')[0].appendChild(script)
    let time = setTimeout(() => { // 如果超出时间就不阻塞，进行成功
      if (fig) {
        return
      }
      succ(false)
    }, 500)
    script.onload = function () { // js加载完成执行方法
      fig = true
      clearTimeout(time)
      succ(true)
    }
  },
  getToCAppStatic(url) {
    return this.$env.res + '/src/images/app-to-c' + url
  },
  jsonConverters(url, json, isCode) { // 将json更换为url String
    if (!json || this.isEmptyObject(json)) return url
    let symbol
    url.indexOf('?') !== -1 ? symbol = '&' : symbol = '?'
    return url + symbol + Object.keys(json).map(function (key) {
      if (isCode) {
        return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`
      } else {
        return `${key}=${json[key]}`
      }
    }).join('&')
  },
  isEmptyObject(json) { // 判断json是否为空
    return Object.keys(json).length === 0
  },
  getHistoryEditText(current) { // 得到历史编辑文本
    return new Promise((resolve, reject) => {
      this.$request.get({
        path: '/fileDeal/showRichText.do',
        data: {
          filePath: current
        },
        baseURL: this.$env.transbiz,
        isEncode: false,
        platformKey: 'api',
        clog: true
      }).then((res) => {
        let text = res.data.data.join('')
        resolve(text)
      }).catch((res) => {
        reject(res)
        try {
          this.$message.error('获取历史编辑错误!')
        } catch (error) { }
      })
    })
  },
  // 获取url参数
  getRequestUrl() {
    let url = decodeURIComponent(location.href) // 获取url中"?"符后的字串
    const index = url.lastIndexOf('?')
    // eslint-disable-next-line no-new-object
    const theRequest = new Object()
    // eslint-disable-next-line eqeqeq
    if (index != -1) {
      url = url.substring(index, url.length)
      const str = url.substr(1)
      const strs = str.split('&')
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
      }
    }
    return theRequest
  },
  // 判断是否是微信浏览器
  isWx() {
    let flag
    let ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      flag = true
    } else {
      flag = false
    }
    return flag
  },
  parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      }
      if ((typeof time === 'number') && (time.toString().length === 10)) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    // eslint-disable-next-line camelcase
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      // eslint-disable-next-line standard/computed-property-even-spacing
      if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    // eslint-disable-next-line camelcase
    return time_str
  },
  onLongPress(obj, fn = () => { }, time = 500) {
    let timer
    this.on(obj, 'touchstart', () => {
      timer = setTimeout(() => {
        fn()
      }, time);
    })
    this.on(obj, 'touchend', () => {
      clearTimeout(timer)
    })
  },
  offLongPress(obj, fn = () => { }) {
    this.off(obj, 'touchstart', () => {
      this.off(obj, 'touchend', () => {
        fn()
      })
    })
  },
  isAndroid() {
    var u = navigator.userAgent;
    return u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
  },
  // 判断设备为 ios
  isIOS() {
    var u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1;
  },
  /**
   * 获取字典数据
   * @param {*} config: 字典配置
   * @param {*} dict: 字典存储对象
   * @author francklin
   * @created 2021.06.02
   * @updated 2021.06.02
   */
  getDictData(config, dict={}){
    var dictMap = [];
    var reqs = [];
    var keys = [];
    _.mapValues(config,(value,key)=>{
      if(_.isArray(value)){
        dict[key] = value;
      } else if(_.isObject(value)&&_.isNumber(value.code)){
        dictMap.push([value.code,key,value.type]);
      } else if(_.isObject(value)){
        keys.push(key);
        reqs.push(this.$api.invoke(value.api).then((res)=>{
          if(res.success&&_.isArray(res[value.data])){
            return res[value.data].filter((item)=>{
              return !_.isNull(item[value.value]);
            }).map((item)=>{
              return {
                text: item[value.text],
                value: item[value.value]
              }
            });
          }
        }));
      }
    });
    return Promise.all([
      this.$dict.save({
        dicts: dictMap.map((item)=>{
          return item[0];
        })
      }),
      ...reqs
    ]).then((results)=>{
      if(results[0]){
        for(let dictItem of dictMap){
          dict[dictItem[1]] = _.transform(results[0][dictItem[0]],(result,item)=>{
            return result.push({
              text: item.dictValue,
              value: (dictItem[2]=='number'? Number(item.dictCode) : item.dictCode)
            });
          },[]);
        }
      }
      _.forEach(results.slice(1),(item,index)=>{
        dict[keys[index]] = item||[];
      });
      return dict;
    });
  },
  // by francklin 20210401
  logState (data) {
    return new Promise((resolve, reject) => {
      this.$request.httpRequest({
        path: '/',
        data,
        method: 'POST',
        succ: (res) => {
          resolve(res.data)
        },
        fail: (res) => {
          reject(res)
        },
        baseURL: _APP_.DEBUG_ADDRESS,
        noToken: true,
        notError: false,
        isEncode: true,
        clog: false,
        headerToken: false
      })
    })
  }
}
export default _helper
